import * as t from 'io-ts';

import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RFeatureFlagOverrides = t.intersection([
  RLastWriterWinsValue,
  t.type({
    flags: t.record(t.string, t.boolean),
  }),
]);

export type FeatureFlagOverrides = t.TypeOf<typeof RFeatureFlagOverrides>;

export const defaultFeatureFlagOverrides: FeatureFlagOverrides = {
  ...defaultLastWriterWinsValue,
  flags: {},
};

/*
 * Conflict resolution.
 */

export const mergeFeatureFlagOverrides: (
  left: FeatureFlagOverrides,
  right: FeatureFlagOverrides,
) => FeatureFlagOverrides = mergeLastWriterWinsValue;
